<template>
  <a-layout-sider :theme="sideTheme" :class="['side-menu', 'beauty-scroll', isMobile ? null : 'shadow']" width="256px" :collapsible="collapsible" v-model="collapsed" :trigger="null">
<!--    <div :class="['logo', theme]">-->
<!--      <router-link to="/dashboard/workplace">-->
<!--        <img src="@/assets/img/logo.png">-->
<!--        <h1>{{systemName}}</h1>-->
<!--      </router-link>-->
<!--    </div>-->

    <div class="user_left_box">
<!--      <img src="@/assets/img/yunxiao.png" alt="">-->
            <img style="width: 150px; margin-left: -15px;margin-top:-5px;" src="@/assets/img/logo.png" alt="">

    </div>
    <i-menu :theme="theme" :collapsed="collapsed" :options="menuData" @select="onSelect" class="menu beauty-scroll"/>
  </a-layout-sider>
</template>

<script>
import IMenu from './menu'
import {mapGetters, mapState} from 'vuex'
export default {
  name: 'SideMenu',
  components: {IMenu},
  props: {
    collapsible: {
      type: Boolean,
      required: false,
      default: false
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false
    },
    menuData: {
      type: Array,
      required: true
    },
    theme: {
      type: String,
      required: false,
      default: 'dark'
    }
  },
  computed: {
    sideTheme() {
      return this.theme == 'light' ? this.theme : 'dark'
    },
    ...mapState('setting', ['isMobile', 'systemName']),
    ...mapGetters('account', ['user']),
  },
  methods: {
    onSelect (obj) {
      this.$emit('menuSelect', obj)
    }
  }
}
</script>

<style lang="less" scope>
@import "index";

//.ant-menu-item{ margin-top: 0}
</style>
